import * as React from "react";
import { useEffect, useState } from "react";
import { useAxios } from "../../utils/useAxios";
import OrderDetailsMapBox from "../../plugins/components/MapBox/Mapbox";
import { toLngLatMap } from "../../utils/latLog";
import { useParams } from "react-router";

import {
  connectSocket,
  disconnectSocket,
  onLocationUpdate,
  offLocationUpdate,
  //emitTest,
} from "../../utils/updateLocation";

interface Props {
  formId: string;
  formIntData: any;
}

export default function LoadOrdersDetailsId({ formId, formIntData }: Props) {
  const [location, setLocation] = useState<{
    latitude: number;
    longitude: number;
  } | null>(null);

  useEffect(() => {
    connectSocket();

    // emitTest("dileep");

    onLocationUpdate((data) => {
      setLocation(data);
    });

    return () => {
      offLocationUpdate();
      disconnectSocket();
    };
  }, []);

  // const { res, mutate, isPending, error } = useAxios({
  //   url: "/api/auth/tabledata",
  // });

  // useEffect(() => {
  //   if (formId) {
  //     mutate({ formId: "loadorders" });
  //   }
  // }, [formId]);
  // const headers = res?.data?.headers || [];
  // const dataRow = res?.data?.data?.[0] || {};

  const {
    res: resDetails,
    mutate: mutateDetails,
    isPending: isPendingDetails,
    error: errorDetails,
  } = useAxios({
    url: "/api/auth/tabledata",
  });

  useEffect(() => {
    if (formId) {
      mutateDetails({ formId, formIntData });
    }
  }, [formId]);

  const finalData = resDetails?.data?.data?.data;
  const order_pickup_details =
    finalData?.filter(
      (sec: any) => sec?.sectionId === "order_pickup_details",
    ) || {};

  const order_delivery_details =
    finalData?.filter(
      (sec: any) => sec?.sectionId === "order_delivery_details",
    ) || {};

  const driver =
    finalData?.filter((sec: any) => sec?.sectionId === "driver") || {};

  const status =
    driver[0]?.columns?.filter((stats: any) => stats?.field === "status") || {};

  const startLoc =
    order_pickup_details[0]?.columns?.filter(
      (loc: any) => loc?.field === "shipper_pickup_loc",
    ) || {};

  const endLoc =
    order_delivery_details[0]?.columns?.filter(
      (loc: any) => loc?.field === "customer_delivery_loc",
    ) || {};

  const start = toLngLatMap(startLoc[0]?.value);
  const end = toLngLatMap(endLoc[0]?.value);

  if (isPendingDetails) return <p>Loading...</p>;
  if (errorDetails) return <p>Error fetching data</p>;

  return (
    <div
      style={{
        width: "100%",
        minHeight: "500px",
        maxWidth: "1035px",
        overflowX: "auto",
      }}
    >
      <div className="max-w-7xl mx-auto bg-white rounded-lg shadow-md p-6">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-bold text-gray-800">
            {status[0]?.value}
          </h1>
          {/* <span className="bg-red-500 text-white text-xs font-bold uppercase px-2 rounded">
            Late
          </span> */}
        </div>
        <span className="font-bold">Total Detention -</span>
        <div className="text-gray-700 mb-4">
          {/* <p>
            Current location: <strong>18.2 mi W of Prairie Hill, TX</strong> -
            0001 min ago
          </p>
          <p>
            Appt: <strong>04/11 at 0600-1000 (CST)</strong>
          </p>
          <p>
            Trip Distance: <strong>465.00 miles</strong>
          </p> */}
        </div>

        <div className="flex items-center mb-4">
          <img
            src="https://cdn-icons-png.flaticon.com/512/2888/2888724.png"
            alt="Truck"
            className="mr-2 w-[50px]"
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="bg-gray-100 p-4 rounded-lg">
            <h2 className="text-lg font-bold text-gray-800">Stop 1 - Pickup</h2>
            {/* {order_pickup_details[0]?.columns?.map((items: any, index: any) => (
              <div className={index}>1</div>
            ))} */}
            {/* {order_pickup_details[0]?.title} */}
            {order_pickup_details[0]?.columns?.map(
              (items: any, index: number) => {
                return (
                  <p key={index}>
                    {items.label}: <strong>{items.value}</strong>
                  </p>
                );
              },
            )}
            {/* <p className="font-semibold">Kronospan (LA)</p>
            <address className="text-gray-600">
              486 Duraflake Road
              <br />
              Ruston, LA, 71270
            </address>
            <p>
              Appt: <strong>04/09 at 1600-1600 (CST)</strong>
            </p>
            <p>
              Arrived: <strong>04/09 at 1601</strong>
            </p>
            <p>
              Departed: <strong>04/09 at 1716</strong>
            </p>
            <p>
              Detention: <strong>0h 0min</strong>
            </p> */}
          </div>

          <div className="bg-gray-100 p-4 rounded-lg">
            <h2 className="text-lg font-bold text-gray-800">
              Stop 2 - Delivery
            </h2>
            {order_delivery_details[0]?.columns?.map(
              (items: any, index: number) => {
                return (
                  <p key={index}>
                    {items.label}: <strong>{items.value}</strong>
                  </p>
                );
              },
            )}
          </div>
        </div>

        {/* <div className="mt-6">
          <h2 className="text-lg font-bold text-gray-800">Carrier Info</h2>
          <p>
            Driver: <strong>Mark Elliott</strong>
          </p>
          <p>
            Cell #: <strong>903-316-0990</strong>
          </p>
          <p>
            Unit: <strong>168</strong>
          </p>
          <p>
            Trailer: <strong>23836</strong>
          </p>
          <p>
            Dispatch: <strong>Phone #: 909-090-9090</strong>
          </p>
        </div>

        <div className="mt-6">
          <h2 className="text-lg font-bold text-gray-800">Document Section</h2>
          <p>Confirmation</p>
          <img
            src="https://via.placeholder.com/300"
            alt="Document"
            className="my-4 rounded-lg shadow-md"
          />
        </div> */}

        <div className="mt-6">
          <h2 className="text-lg font-bold text-gray-800">Map</h2>
          <div className="bg-gray-200 h-100 rounded-lg overflow-hidden">
            {start && end && (
              <OrderDetailsMapBox
                start={start}
                end={end}
                location={[location]}
              />
            )}
          </div>
        </div>
      </div>

      {/* <div className="w-full mx-auto my-4 d-flex">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <table className="w-full border border-gray-300 rounded-md shadow-sm">
              <tbody>
                {headers.map(({ field, headerName }: any) => (
                  <tr key={field} className="border-b border-gray-200">
                    <td className="px-4 py-2 font-semibold text-gray-700 bg-gray-100 w-1/3">
                      {headerName}
                    </td>
                    <td className="px-4 py-2 text-gray-800 break-words">
                      {Array.isArray(dataRow[field])
                        ? dataRow[field].join(", ")
                        : (dataRow[field] ?? "-")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div>
            {start && end && <OrderDetailsMapBox start={start} end={end} />}
          </div>
        </div>
      </div> */}
    </div>
  );
}
